// services/emailService.ts

export async function sendOrderEmail(email: string, orderId: string): Promise<void> {
    try {
        const response = await fetch('/api/email-orders', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, orderId }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error("Error enviando correo:", errorData.message);
            throw new Error(errorData.message || "Error enviando correo al comprador.");
        }

        console.log("Correo enviado correctamente.");
    } catch (error) {
        console.error("Error llamando a la API:", error);
        throw error;
    }
}
export default sendOrderEmail